import * as sites from 'goodeggs-sites';

export default __filename;
angular
  .module(__filename, [])

  .factory(
    'externalUrls',
    ngInject((settings) => ({
      getAvailabilityUrl: (foodhubSlug, marketProductId) => {
        const url = sites.getUrl('availability-api', settings);
        return `${url}/v1/view/${foodhubSlug}?productId=${marketProductId}`;
      },

      getOrderingReportUrl(vendorSlug) {
        return `https://modeanalytics.com/goodeggs/reports/fbb9edd8277d?param_product_type=all&param_vendor_slug=${vendorSlug}`;
      },
    })),
  );
